import $ from "jquery"

class Factsheet {
	constructor() {
		// eslint-disable-next-line no-console
		console.log("Factsheet::initialize()")

		$(document)
			.on("shown.bs.tab", ".bb-factsheet__chart-tabs", (event) => {
				let customEvent = $.Event("chart::resizeByContainer", { $chartContainer: $($(event.currentTarget).data("bs-target")) })
				$(document).trigger(customEvent)
			})
			.on("shown.bs.tab", ".bb-factsheet__chart-tabs", (event) => {
				let customEvent = $.Event("chart::changeToFirstRangeByContainer", { $chartContainer: $($(event.currentTarget).data("bs-target")) })
				$(document).trigger(customEvent)
			})

	}



}

export default Factsheet
